import { EPublishTermsAvailableMoneySources } from '../../../../../types/reducers/publishTerms';
import { EMoneySource } from '../../../../../types/reducers/user';

import { IMoneySourceWidgetOption } from '../types';

export const getOptions = (availableSources: EPublishTermsAvailableMoneySources): IMoneySourceWidgetOption[] => {
  return [
    {
      disabled:
        availableSources !== EPublishTermsAvailableMoneySources.MasterAndSelf &&
        availableSources !== EPublishTermsAvailableMoneySources.Master,
      value: EMoneySource.Master,
      label: 'Агентство',
    },
    {
      disabled:
        availableSources !== EPublishTermsAvailableMoneySources.MasterAndSelf &&
        availableSources !== EPublishTermsAvailableMoneySources.Self,
      value: EMoneySource.Self,
      label: 'Личный',
    },
  ];
};
